import * as React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {RichIcon, Text, Section} from 'components/UIKit';
import styles from './WhyExchange.scss';
import * as locales from './locales';

interface WhyExchangeProps {}

function WhyExchangeComponent({i18n}: WhyExchangeProps & WithI18nProps) {
  return (
    <Section
      heading={i18n.translate('whyUse')}
      subhead={i18n.translate('whyUseSub')}
      headingProps={{align: 'center'}}
      subheadProps={{align: 'center'}}
      headerSpacing="medium"
    >
      <div className={styles.Container}>
        {locales.en.items.map((item, index) => (
          <div className={styles.Block} key={item.icon}>
            <RichIcon icon={item.icon} size={40} className={styles.Icon} />
            <Text
              text={i18n.translate(`items.${index}.heading`)}
              type="h3"
              component="h3"
              inheritColor
            />
            <Text text={i18n.translate(`items.${index}.content`)} component="p" inheritColor />
          </div>
        ))}
      </div>
    </Section>
  );
}

export const WhyExchange = withI18n({
  id: 'WhyExchange',
  fallback: locales.en,
})(WhyExchangeComponent);
